import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Int_SortEvent, Int_TableColumn } from "../../../models/components";

@Component({
  selector: "mobi-office-lib-table-sorting",
  imports: [CommonModule, MatIconModule, MatMenuModule],
  templateUrl: "./table-sorting.component.html",
  styleUrl: "./table-sorting.component.scss",
})
export class TableSortingComponent {
  @Input({ required: true }) item!: Int_TableColumn;
  @Input({ required: true }) inputSortOrder: Int_SortEvent = {
    sortOrder: "",
    sortBy: "",
  };

  sortBy: string = "";
  @Output() inputSortOrderChange = new EventEmitter<Int_SortEvent>();

  onSortEmitter(sortOrder: string) {
    this.inputSortOrder.sortOrder = sortOrder;
    this.inputSortOrder.sortBy = this.sortBy;
    this.inputSortOrderChange.emit(this.inputSortOrder);
  }
}
